import { Helmet } from 'react-helmet';
import type { FAQPage, WithContext } from 'schema-dts';
import type { FAQSchemaItem } from '../../pages/gift-cards/components/GiftCardsFAQSection/GiftCardsFAQSection';

type FAQSchemaProps = {
    faqItems: FAQSchemaItem[];
};

export const FAQSchema = ({ faqItems }: FAQSchemaProps): JSX.Element => {
    const jsonLd: WithContext<FAQPage> = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqItems.map((item) => ({
            '@type': 'Question',
            name: item.title,
            acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer,
            },
        })),
    };

    return (
        <Helmet>
            <script type="application/ld+json" data-testid="faq-schema">
                {JSON.stringify(jsonLd, null, 2)}
            </script>
        </Helmet>
    );
};
